import { Button, Link, Paragraph } from '@sentara-health/optimahealth_web';
import { t } from 'i18next';
import { HeaderContentProps } from 'templates';

function ProfileHeaderContent({
  header,
  contentOrObject,
  contentOne,
  contentTwo,
  className,
  onClick,
  onChangeAddress,
  disabledText,
  dataTestIdOne,
  dataTestIdTwo,
  contentClassNameOne,
  contentClassNameTwo,
  showButton = false,
  showChangeAddress = false,
  fieldName = '',
  disableButton = false,
}: Readonly<HeaderContentProps>) {
  return (
    <div className="row d-flex align-items-center">
      <div
        className={
          !showButton
            ? 'col-12'
            : 'col-12 col-md-9'
        }
      >
        {header ? (
          <Paragraph
            text={header}
            variant="bold"
            dataTestId={'header'}
            className={`${className} mb-1`}
          />) : null}
        {contentOrObject ? (
            <>{contentOrObject}</>
        ) : null}
        {contentOne ? (
          <Paragraph
            text={contentOne}
            variant="regular"
            data-testid={dataTestIdOne}
            className={contentClassNameOne}
            disabled={disabledText}
            textColor={disabledText ? 'disable' : 'primary'}
          />
        ) : null}
        {contentTwo ? (
          <Paragraph
            text={contentTwo}
            variant="regular"
            data-testid={dataTestIdTwo}
            className={`${contentClassNameTwo} mt-1 ${showChangeAddress ? 'mb-2' : 'mb-0'}`}
          />
        ) : null}
        {showChangeAddress ? (
          <div className={` mt-md-3 mb-1`}>
            <Link
              dataTestId={'changeAddressButton'}
              variant='secondary_btn'
              onClick={onChangeAddress}
            >{t('profile.changeHomeAddress')}</Link>
          </div>
        ) : null}
      </div>
      {showButton ? (
        <div
          className={`col-md-3 col-12 text-end mb-sm-0 mb-1`}
        >
          <Button
            dataTestId={t('common.edit') ? t('common.edit') : 'editButton'}
            variant='secondary_btn'
            onClick={onClick}
            disabled={disableButton}
          >{t('common.edit')}</Button>
        </div>
      ) : null}
    </div>
  );
}

export default ProfileHeaderContent;
